export const parseRawURLSearchParams = (searchParamsString: string): Record<string, string> => {
  return searchParamsString
    .replace(/^\?/, "") // Remove the first character only if it is a ?
    .split("&")
    .reduce(
      (acc, keyValue) => {
        const [key, value] = keyValue.split("=");
        acc[key] = value;
        return acc;
      },
      {} as Record<string, string>
    );
};
